function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 Bootstrap 4 integration for DataTables' Responsive
 ©2016 SpryMedia Ltd - datatables.net/license
*/
(function (c) {
  "function" === typeof define && define.amd ? define(["jquery", "datatables.net-bs4", "datatables.net-responsive"], function (a) {
    return c(a, window, document);
  }) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = function (a, b) {
    a || (a = window);
    if (!b || !b.fn.dataTable) b = require("datatables.net-bs4")(a, b).$;
    b.fn.dataTable.Responsive || require("datatables.net-responsive")(a, b);
    return c(b, a, a.document);
  } : c(jQuery, window, document);
})(function (c) {
  var a = c.fn.dataTable,
      b = a.Responsive.display,
      g = b.modal,
      e = c('<div class="modal fade dtr-bs-modal" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"/></div></div></div>');

  b.modal = function (a) {
    return function (b, d, f) {
      if (c.fn.modal) {
        if (!d) {
          if (a && a.header) {
            var d = e.find("div.modal-header"),
                h = d.find("button").detach();
            d.empty().append('<h4 class="modal-title">' + a.header(b) + "</h4>").append(h);
          }

          e.find("div.modal-body").empty().append(f());
          e.appendTo("body").modal();
        }
      } else g(b, d, f);
    };
  };

  return a.Responsive;
});